import Flag from 'react-country-flag';

// Matches src/misc/misc.controller.ts's getSupportedLanguages (hubert-internal-manager-backend),
// which reads the `languages` collection filtered to is_supported: true — not the (stale, narrower
// and in places inconsistent) TAvailableLanguageCodes union from @hubertai/screening-question-types.
export const LanguageTexts = {
  '': '',
  'sq-al': 'Albanian',
  'bs-ba': 'Bosnian',
  'bg-bg': 'Bulgarian',
  'bg-bg-Latn': 'Bulgarian (Latin script)',
  'zh-cn': 'Chinese',
  'hr-hr': 'Croatian',
  'cs-cz': 'Czech',
  'da-dk': 'Danish',
  'nl-nl': 'Dutch',
  'en-gb': 'British English',
  'en-us': 'American English',
  'fi-fi': 'Finnish',
  'fr-fr': 'French',
  'de-de': 'German',
  'el-gr': 'Greek',
  'el-gr-Latn': 'Greek (Latin script)',
  'ht-ht': 'Haitian Creole',
  'he-il': 'Hebrew',
  'hi-in': 'Hindi',
  'hi-in-Latn': 'Hindi (Latin script)',
  'hu-hu': 'Hungarian',
  'id-id': 'Indonesian',
  'it-it': 'Italian',
  'ja-jp': 'Japanese',
  'ko-kr': 'Korean',
  'mr-in': 'Marathi',
  'no-no': 'Norwegian (Bokmål)',
  'nn-no': 'Norwegian (Nynorsk)',
  'pl-pl': 'Polish',
  'pt-pt': 'Portuguese',
  'ro-ro': 'Romanian',
  'ru-ru': 'Russian',
  'sr-rs': 'Serbian',
  'sr-rs-Latn': 'Serbian (Latin script)',
  'sk-sk': 'Slovak',
  'ca-es': 'Catalan',
  'es-es': 'Spanish',
  'sv-se': 'Swedish',
  'tr-tr': 'Turkish',
  'uk-ua': 'Ukrainian',
  'af-za': 'Afrikaans',
  'ar-001': 'Arabic',
  'ar-001-Latn': 'Arabic (Latin script)',

  sv: 'Swedish',
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  de: 'German',
  no: 'Norwegian',
  da: 'Danish',
  fi: 'Finnish',
};

export const LanguageFlags = {
  '': '',
  'sq-al': <Flag countryCode={'AL'} svg className="!size-5" />,
  'bs-ba': <Flag countryCode={'BA'} svg className="!size-5" />,
  'bg-bg': <Flag countryCode={'BG'} svg className="!size-5" />,
  'bg-bg-Latn': <Flag countryCode={'BG'} svg className="!size-5" />,
  'zh-cn': <Flag countryCode={'CN'} svg className="!size-5" />,
  'hr-hr': <Flag countryCode={'HR'} svg className="!size-5" />,
  'cs-cz': <Flag countryCode={'CZ'} svg className="!size-5" />,
  'da-dk': <Flag countryCode={'DK'} svg className="!size-5" />,
  'nl-nl': <Flag countryCode={'NL'} svg className="!size-5" />,
  'en-gb': <Flag countryCode={'GB'} svg className="!size-5" />,
  'en-us': <Flag countryCode={'US'} svg className="!size-5" />,
  'fi-fi': <Flag countryCode={'FI'} svg className="!size-5" />,
  'fr-fr': <Flag countryCode={'FR'} svg className="!size-5" />,
  'de-de': <Flag countryCode={'DE'} svg className="!size-5" />,
  'el-gr': <Flag countryCode={'GR'} svg className="!size-5" />,
  'el-gr-Latn': <Flag countryCode={'GR'} svg className="!size-5" />,
  'ht-ht': <Flag countryCode={'HT'} svg className="!size-5" />,
  'he-il': <Flag countryCode={'IL'} svg className="!size-5" />,
  'hi-in': <Flag countryCode={'IN'} svg className="!size-5" />,
  'hi-in-Latn': <Flag countryCode={'IN'} svg className="!size-5" />,
  'hu-hu': <Flag countryCode={'HU'} svg className="!size-5" />,
  'id-id': <Flag countryCode={'ID'} svg className="!size-5" />,
  'it-it': <Flag countryCode={'IT'} svg className="!size-5" />,
  'ja-jp': <Flag countryCode={'JP'} svg className="!size-5" />,
  'ko-kr': <Flag countryCode={'KR'} svg className="!size-5" />,
  'mr-in': <Flag countryCode={'IN'} svg className="!size-5" />,
  'no-no': <Flag countryCode={'NO'} svg className="!size-5" />,
  'nn-no': <Flag countryCode={'NO'} svg className="!size-5" />,
  'pl-pl': <Flag countryCode={'PL'} svg className="!size-5" />,
  'pt-pt': <Flag countryCode={'PT'} svg className="!size-5" />,
  'ro-ro': <Flag countryCode={'RO'} svg className="!size-5" />,
  'ru-ru': <Flag countryCode={'RU'} svg className="!size-5" />,
  'sr-rs': <Flag countryCode={'RS'} svg className="!size-5" />,
  'sr-rs-Latn': <Flag countryCode={'RS'} svg className="!size-5" />,
  'sk-sk': <Flag countryCode={'SK'} svg className="!size-5" />,
  'ca-es': <Flag countryCode={'ES'} svg className="!size-5" />,
  'es-es': <Flag countryCode={'ES'} svg className="!size-5" />,
  'sv-se': <Flag countryCode={'SE'} svg className="!size-5" />,
  'tr-tr': <Flag countryCode={'TR'} svg className="!size-5" />,
  'uk-ua': <Flag countryCode={'UA'} svg className="!size-5" />,
  'af-za': <Flag countryCode={'ZA'} svg className="!size-5" />,
};
